import produce from 'immer';
import { combineReducers } from 'redux';

import type { Action } from 'Lib/reduxType';

import { DYNAMIC_FEATURE_COMPLETE, DYNAMIC_REDUCER_COMPLETE } from './constants';
import initialState from './initialState';
import type { DynamicLoadingState } from './types';

const dynamicReducersReducer = produce<DynamicLoadingState['dynamicReducers'], [Action]>(
  (draft, action) => {
    switch (action.type) {
      case DYNAMIC_REDUCER_COMPLETE: {
        const reducersName = action.payload;
        reducersName.forEach((reducerName: string) => {
          draft[reducerName] = true;
        });
        break;
      }
    }
  },
  initialState.dynamicReducers
);

const dynamicFeaturesReducer = produce<DynamicLoadingState['dynamicFeatures'], [Action]>(
  (draft, action) => {
    switch (action.type) {
      case DYNAMIC_FEATURE_COMPLETE: {
        const asyncBundleName = action.payload;
        draft[asyncBundleName] = true;
        break;
      }
    }
  },
  initialState.dynamicFeatures
);

export const reducer = combineReducers({
  dynamicReducers: dynamicReducersReducer,
  dynamicFeatures: dynamicFeaturesReducer,
});
